import { ChangePasswordForm, type ChangePasswordPayload } from "./change-password-form";

// US-076 — self-service change-password dialog.
//
// Opened from the account menu (app-header) next to "Sign out". Thin backdrop
// modal around the shared <ChangePasswordForm>, mirroring add-user-dialog: a
// click on the backdrop does NOT close it (explicit Cancel / submit only) so
// in-progress input can't be discarded by accident. The parent owns the POST
// to /api/auth/change-password, the submitting/error state, and the success
// toast.

interface ChangePasswordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (payload: ChangePasswordPayload) => void | Promise<void>;
  submitting: boolean;
  error?: string;
}

export function ChangePasswordDialog({
  open,
  onOpenChange,
  onSubmit,
  submitting,
  error,
}: ChangePasswordDialogProps) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="change-password-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
    >
      <div className="w-full max-w-md rounded-2xl bg-card border border-border shadow-elegant p-6 space-y-4 max-h-[90vh] overflow-y-auto">
        <div>
          <h2 id="change-password-title" className="text-lg font-semibold tracking-tight">
            Change password
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Enter your current password and choose a new one for your account.
          </p>
        </div>

        <ChangePasswordForm
          onSubmit={onSubmit}
          submitting={submitting}
          error={error}
          onCancel={() => onOpenChange(false)}
        />
      </div>
    </div>
  );
}
